import React, { useState, useContext } from 'react';

import { Row, Col } from 'antd';
import Axios from 'axios';
import { Formik, Field } from 'formik';
import * as Yup from 'yup';

import styled from 'styled-components';

import { validateVisibility } from '@libs/NwUtils';

import { ListContext } from '@contexts/ListContext';
import { useStateValue } from '@contexts/StateProvider';

import { forceReloadContact } from '@hooks/API/Contact/UseContact';

import { NwSaveButton, NwCancelButton } from '@components/Gui/NwButton';
import NwDrawer from '@components/Gui/NwDrawer';
import { NWVisibilitySelector, NWTextAreaCharCounter, NWSelect } from '@components/Gui/NwForm/NwFormItems';
import { NwForm, NwFormButtonsBar } from '@components/Gui/NwForm/NwFormWrapper';

const StyledRow = styled(Row)`
    .ant-select-selection-item {
        flex: unset;
    }
`;

const NoteAddEditDrawer = ({ contactID, note, afterNotesCreation, billingNote = false }) => {
    const [{ areaContext }] = useStateValue();
    const { cachedList } = useContext(ListContext);
    const [touchForm, setTouchForm] = useState(false);

    let initialValues = {
        Text: note ? note.Text : '',
        Type: note ? note.NoteTypeCode : billingNote ? 'BILLING' : cachedList.noteTypes.items[0].Code,
        Visibility: billingNote
            ? {
                  isGlobal: false,
                  Areas: ['accounting'],
              }
            : {
                  isGlobal: true,
                  Areas: [],
              },
    };

    const addNote = async (values, setStatus, setSubmitting) => {
        setSubmitting(true);

        if (note) {
            Axios.put('/notes', {
                ID: note.ID,
                NoteTypeCode: values.Type,
                Text: values.Text,
                PrivacyLevel: 'Public',
                ContactID: contactID,
                VisibilityAreas: values.Visibility.Areas,
            })
                .then(() => {
                    setTouchForm(false);
                    //onUpdateNotes(contactID);
                    console.error('after edit note', contactID);
                    forceReloadContact(contactID);
                    afterNotesCreation();
                })
                .catch((error) => {
                    console.error('errore', error);
                });
        } else {
            Axios.post('/notes', {
                NoteTypeCode: values.Type,
                Text: values.Text,
                PrivacyLevel: 'Public',
                ContactID: contactID,
                VisibilityAreas: values.Visibility.Areas,
            })
                .then(() => {
                    setTouchForm(false);
                    forceReloadContact(contactID);
                    afterNotesCreation();
                })
                .catch((error) => {
                    console.error('errore', error);
                });
        }
    };

    return (
        <NwDrawer
            onTouchForm={setTouchForm}
            touchForm={touchForm}
            title={note ? 'Edit Note' : 'Add Note'}
            onClose={afterNotesCreation}
        >
            <Formik
                initialValues={initialValues}
                validationSchema={Yup.object().shape({
                    Text: Yup.string().required('Content is required'),
                })}
                onSubmit={(values, { setStatus, setSubmitting }) => {
                    setStatus();
                    addNote(values, setStatus, setSubmitting);
                }}
            >
                {({ isSubmitting, handleSubmit, values }) => (
                    <NwForm values={values} onTouchForm={setTouchForm} onFinish={handleSubmit} layout="vertical">
                        <StyledRow>
                            <Col lg={12} md={12} sm={12} xs={24}>
                                <Field
                                    component={NWVisibilitySelector}
                                    label="Visibility"
                                    inlineLabel
                                    name="Visibility"
                                    value={values.Visibility}
                                    validate={validateVisibility(values.Visibility, areaContext.area)}
                                />
                            </Col>
                            <Col lg={12} md={12} sm={12} xs={24} style={{ textAlign: 'right' }}>
                                <Field
                                    component={NWSelect}
                                    label="Note category"
                                    name="Type"
                                    inlineLabel
                                    value={values.Type}
                                    options={cachedList.noteTypes.items.map((el) => {
                                        return { key: el.Code, label: el.Name, value: el.Code };
                                    })}
                                />
                            </Col>
                        </StyledRow>
                        <Field
                            component={NWTextAreaCharCounter}
                            label="Note"
                            name="Text"
                            type="text"
                            required
                            value={values.Text}
                            maxLength={4000}
                            style={{ width: '100%' }}
                            autoSize={{ minRows: 5, maxRows: 6 }}
                        />
                        <NwFormButtonsBar
                            left={
                                <NwCancelButton
                                    disabled={isSubmitting}
                                    onClick={() => {
                                        setTouchForm(false);
                                        afterNotesCreation();
                                    }}
                                />
                            }
                            right={<NwSaveButton disabled={isSubmitting} loading={isSubmitting} />}
                        />
                    </NwForm>
                )}
            </Formik>
        </NwDrawer>
    );
};

export default NoteAddEditDrawer;
